import {ApplicationRoute, LOCALIZED_ROUTE_TOKEN} from '../../craft/utils/application.route'

export const USER_ROUTES = {
  USER: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/user`), // hardcoded in app-module to allow tree shaking routes
  USER_MESSAGES: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/user/messages`),
  USER_MESSAGES_DEFAULT: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/user/messages/default`, 'default'),
  USER_MESSAGES_ROOM: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/user/messages/:roomId`, ':roomId'),
}
